import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { TMissionOrBadge } from '@smartico/public-api/dist/WSAPI/WSAPITypes'
import { Smartico } from '../../core/Smartico'

interface MissionsState {
    missions: TMissionOrBadge[]
    error: string | null
}

const initialState: MissionsState = {
    missions: [],
    error: null,
}

export const fetchMissions = createAsyncThunk('missions/fetchMissions', async (_, { rejectWithValue }) => {
    try {
        const smarticoApi = await Smartico.apiReady
        const missionsResponse = await smarticoApi.getMissions({ onUpdate: () => {} })
        return missionsResponse
    } catch (error) {
        return rejectWithValue('Failed to fetch missions')
    }
})

export const subscribeToMissionUpdates = createAsyncThunk('missions/subscribeToMissionUpdates', async (_, { dispatch }) => {
    const smarticoApi = await Smartico.apiReady

    smarticoApi.getMissions({
        onUpdate: (updatedMissions: TMissionOrBadge[]) => {
            if (updatedMissions && updatedMissions.length > 0) {
                dispatch(updateMissions(updatedMissions))
            }
        },
    })
})

const missionsSlice = createSlice({
    name: 'missions',
    initialState,
    reducers: {
        setMissions(state, action: PayloadAction<TMissionOrBadge[]>) {
            state.missions = action.payload
        },
        updateMissions(state, action: PayloadAction<TMissionOrBadge[]>) {
            state.missions = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMissions.pending, (state) => {
                state.missions = []
                state.error = null
            })
            .addCase(fetchMissions.fulfilled, (state, action) => {
                state.missions = action.payload
                state.error = null
            })
            .addCase(fetchMissions.rejected, (state, action) => {
                state.missions = []
                state.error = action.payload as string
            })
    },
})

export const { setMissions, updateMissions } = missionsSlice.actions

export default missionsSlice.reducer
